import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { Box } from '@customerio/pluma-components/react';
import type { ComponentProps } from 'react';
import * as styles from './index.css';
import { assignInlineVars } from '@vanilla-extract/dynamic';

export function GradientRing({
  children,
  className,
  radius = 6,
  ringSize,
  alwaysVisible = false,
  style,
  ...rest
}: ComponentProps<typeof Box> & {
  radius?: keyof typeof themeVars.radius;
  ringSize?: string;
  alwaysVisible?: boolean;
}) {
  const vars: Record<string, string> = {
    [styles.ringRadius]: themeVars.radius[radius],
  };
  if (ringSize != null && ringSize !== '') {
    vars[styles.ringSize] = ringSize;
  }
  return (
    <Box {...rest} className={[styles.gradientContainer, className]} style={[style, assignInlineVars(vars)]}>
      <div className={`${styles.gradientRing}${alwaysVisible ? ` ${styles.alwaysVisible}` : ''}`} />
      {children}
    </Box>
  );
}

export { gradientBackground } from './index.css';
